import * as yup from 'yup';
import { STORE_VALIDATION_MESSAGES, STORE_CONFIG } from '../constants';

export const createStoreSchema = yup.object().shape({
  name: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.NAME_REQUIRED)
    .min(2, STORE_VALIDATION_MESSAGES.NAME_MIN_LENGTH)
    .max(100, STORE_VALIDATION_MESSAGES.NAME_MAX_LENGTH),
  address: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.ADDRESS_REQUIRED),
  city: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.CITY_REQUIRED),
  state: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.STATE_REQUIRED),
  zip_code: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.ZIP_CODE_REQUIRED)
    .matches(STORE_CONFIG.ZIP_CODE_REGEX, STORE_VALIDATION_MESSAGES.ZIP_CODE_INVALID),
  phone_number: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.PHONE_REQUIRED)
    .matches(STORE_CONFIG.PHONE_REGEX, STORE_VALIDATION_MESSAGES.PHONE_INVALID),
  email: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.EMAIL_REQUIRED)
    .matches(STORE_CONFIG.EMAIL_REGEX, STORE_VALIDATION_MESSAGES.EMAIL_INVALID),
});

export const updateStoreSchema = yup.object().shape({
  name: yup
    .string()
    .min(2, STORE_VALIDATION_MESSAGES.NAME_MIN_LENGTH)
    .max(100, STORE_VALIDATION_MESSAGES.NAME_MAX_LENGTH),
  address: yup.string(),
  city: yup.string(),
  state: yup.string(),
  zip_code: yup
    .string()
    .matches(STORE_CONFIG.ZIP_CODE_REGEX, STORE_VALIDATION_MESSAGES.ZIP_CODE_INVALID),
  phone_number: yup
    .string()
    .matches(STORE_CONFIG.PHONE_REGEX, STORE_VALIDATION_MESSAGES.PHONE_INVALID),
  email: yup
    .string()
    .matches(STORE_CONFIG.EMAIL_REGEX, STORE_VALIDATION_MESSAGES.EMAIL_INVALID),
});

export const inviteUserSchema = yup.object().shape({
  name: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.USER_NAME_REQUIRED),
  email: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.USER_EMAIL_REQUIRED)
    .matches(STORE_CONFIG.EMAIL_REGEX, STORE_VALIDATION_MESSAGES.USER_EMAIL_INVALID),
  phone_number: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.USER_PHONE_REQUIRED)
    .matches(STORE_CONFIG.PHONE_REGEX, STORE_VALIDATION_MESSAGES.USER_PHONE_INVALID),
  role: yup
    .string()
    .required(STORE_VALIDATION_MESSAGES.USER_ROLE_REQUIRED)
    .oneOf(['admin', 'manager', 'employee'], 'Invalid role'),
});

export const updateUserSchema = yup.object().shape({
  name: yup.string(),
  email: yup
    .string()
    .matches(STORE_CONFIG.EMAIL_REGEX, STORE_VALIDATION_MESSAGES.USER_EMAIL_INVALID),
  phone_number: yup
    .string()
    .matches(STORE_CONFIG.PHONE_REGEX, STORE_VALIDATION_MESSAGES.USER_PHONE_INVALID),
  role: yup
    .string()
    .oneOf(['admin', 'manager', 'employee'], 'Invalid role'),
  status: yup
    .string()
    .oneOf(['active', 'inactive'], 'Invalid status'),
});

export const logoValidationSchema = yup.object().shape({
  logo: yup
    .mixed()
    .required('Logo is required')
    .test('fileSize', STORE_VALIDATION_MESSAGES.LOGO_SIZE_LIMIT, (value) => {
      if (!value) return true;
      const file = value as File;
      return file.size <= STORE_CONFIG.LOGO_MAX_SIZE;
    })
    .test('fileType', STORE_VALIDATION_MESSAGES.LOGO_TYPE_INVALID, (value) => {
      if (!value) return true;
      const file = value as File;
      return STORE_CONFIG.ALLOWED_LOGO_TYPES.includes(file.type as any);
    }),
}); 